module.exports = "/images/NavIcon.png?02ece60a8d0b8753a19953c504662c8b";